import keysToConstants from 'js/lib/keysToConstants';

const SubscriptionStatus = keysToConstants(['ACTIVE', 'CANCELLED', 'FREE_TRIAL', 'INACTIVE', 'PAST_DUE', 'EXPIRED']);

export const { ACTIVE, CANCELLED, FREE_TRIAL, INACTIVE, PAST_DUE, EXPIRED } = SubscriptionStatus;

export default SubscriptionStatus;
